<template>
	<div v-if="visible" class="toast-message" @click="hideNotification">
		<span
			class="toast-message-text"
			v-html="currentMessageParam.message"
		></span>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import eventBus from '@vrp/js/eventBus'; // eventBus 가져오기
import { Queue } from '@vrp/js/queue.js';

const queue = new Queue();
const visible = ref(false);
const currentMessageParam = ref({});
const isShowingMessage = ref(false);

function showNotification(message) {
	if (!isShowingMessage.value) {
		queue.enqueue(message);
		displayNextNotification();
	} else {
		queue.clear();
	}
}

function displayNextNotification() {
	if (!queue.isEmpty()) {
		const nextMessage = queue.dequeue();
		currentMessageParam.value = { message: nextMessage }; // HTML 메시지를 전달
		visible.value = true;
		isShowingMessage.value = true;

		// 자동으로 일정 시간 후에 사라지도록 설정 (예: 3초 후에 숨기기)
		setTimeout(() => {
			hideNotification();
		}, 3000);
	}
}

function hideNotification() {
	visible.value = false;
	isShowingMessage.value = false;
	// 메시지를 숨긴 후 큐에서 다음 메시지를 표시
	if (!queue.isEmpty()) {
		displayNextNotification();
	}
}

eventBus.on('notification-toast:show', message => {
	showNotification(message);
});

eventBus.on('notification-toast:hide', () => {
	if (visible.value) {
		hideNotification();
	}
});
</script>

<style scoped>
.toast-message {
	position: fixed;
	top: 20px; /* 상단에 위치 */
	left: 50%;
	transform: translateX(-50%);
	background-color: rgba(
		50,
		50,
		50,
		0.9
	); /* 배경을 어두운 회색으로, 불투명도 조정 */
	color: #ffffff; /* 글자 색상: 흰색 */
	padding: 10px 20px;
	border-radius: 5px;
	font-size: 14px;
	z-index: 9999;
	width: 400px; /* 너비 150px */
	text-align: center; /* 텍스트 가운데 정렬 */
	word-wrap: break-word; /* 텍스트가 길면 줄바꿈 */
	overflow-wrap: break-word; /* 긴 단어가 줄을 넘지 않도록 줄바꿈 */
	white-space: normal; /* 줄바꿈 허용 */
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* 그림자 추가 */
	cursor: pointer; /* 클릭하여 숨기기 기능 */
	text-align: left;
}

.toast-message-text {
	color: var(--common_white, #fff);
	font-family: 'Noto Sans KR';
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}
</style>
